import { Step } from 'semantic-ui-react';
import styled from 'styled-components';

export const StepDescr = styled(Step.Description)`
overflow: hidden;
text-overflow: ellipsis;
display: -webkit-box;
-webkit-line-clamp: 3;
-webkit-box-orient: vertical;    
font-size: 11px !important;
`
export const StyledDimmer = styled.div`
display: flex;
align-items: center;
flex-direction: column;
justify-content: center;
margin-top: 100px;
`
export const StyledDateWrapper = styled.div`
display: flex;
flex-direction: column;
gap: 5px;
align-items: baseline;
  input[name="date"] {
    width: 230px !important;
  }
`
export const ActionsWrapper = styled.div`
display: flex;
flex-wrap: wrap;
gap: 5px;
.ui.labeled.icon.button, .ui.labeled.icon.buttons .button {
  padding-left: 3.07142857em !important;
  padding-right: 1em !important;
}
 button {
  display: inline-flex;
  cursor: pointer;
  align-items: center !important;
  justify-content: center !important;
  border-radius: 0.375rem !important;
  border-width: 1px !important;
  font-size: 1rem !important;
  padding-top: 0.75rem !important;
  padding-bottom: 0.75rem !important;
  padding-left: 1.75rem !important;
  padding-right: 1.75rem !important;
  font-size: 1.15rem !important;
  font-weight: 500 !important;
  color: #ffffff !important;
  box-shadow: 0 0 #000000, 0 0 #000000, 0 4px 6px -1px rgb(0, 0, 0, 0.1),
    0 2px 4px -2px rgb(0, 0, 0, 0.1) !important;

  & > div {
  font-size: 1.15rem !important;
  font-weight: 500 !important;
  }
 }
`
export const ProgressWrapper = styled.div`
  .bar {
    height: 37px !important;
  }
  .ui.progress .bar>.progress {
    right: 0em !important;
    font-size: 12px !important;
  }
`